import {useEffect, useState} from "react";

const ImageWithFallback = ({
                             alt,
                             src,
                             fallBack = "/images/template/plain-white-background.png",
                             ...props
                           }) => {
  const [error, setError] = useState(null);
  useEffect(() => {
    setError(null);
  }, [src]);

  return (
    <img
      alt={alt}
      onError={setError}
      src={error || src == null ? fallBack : src}
      {...props}
    />
  );
};

export default ImageWithFallback;
